import * as React from "react";
import {Button, Input, Table} from "semantic-ui-react";
import AceEditor from "react-ace";

import 'brace/theme/monokai'
import 'brace/ext/searchbox'
import {Splitter} from "../../../util/table-splitter-ui/src/components/Splitters/Splitter";
import {backend} from "../../../../xconvert-backend";
import {authentication} from "../../../../authentication";
import { Header,  Modal} from "semantic-ui-react";
import {ImmediateFormatEntry} from "../../../../generated";
import {string} from "prop-types";

export interface LinkingViewerProps {
    output: string
}


export function LinkingViewer(props: React.PropsWithChildren<LinkingViewerProps>) {

    const [orderData1, setOrderData1] = React.useState<string>("")
    const [orderData2, setOrderData2] = React.useState<string>("")
    const [linkKeyModalIsOpen, setLinkKeyModalOpen] = React.useState(false)

    function ImmediateFormatViewer(orderData: string, setOrderData: React.Dispatch<React.SetStateAction<string>>){
        const [orderId, setOrderId] = React.useState<string>("")

        const [loading, setLoading] = React.useState<boolean>(false)


        async function loadOrder(){
            setLoading(true)
            try{
                let auth = (await backend.withTokenAuthHeader(authentication.token))
                const order = await backend.internalApi.viewTransportOrderAsImmediateFormat(orderId, auth)

                setOrderData(JSON.stringify(order.entries, null, 2))

            }catch (e){
                console.error(e)
            }finally {
                setLoading(false)
            }
        }

        return <>
            <Input style={{ width: 220 }} placeholder='Order ID'
                   value={orderId}
                   onChange={(evt) => setOrderId(evt.target.value )}
            />
            <Button id='LoadOrderInImmediateFormat' primary loading={loading} onClick={() => { loadOrder() }}>Load</Button>
            <AceEditor
                mode="xml"
                theme="monokai"
                value={orderData}
                readOnly={true}
                width="100%"
                height="100%"
            />
        </>
    }

    function DisplayOrdersSideBySide() {

        return <>
            <Splitter name={"LinkingSplitter"} left={ImmediateFormatViewer(orderData1,setOrderData1)} right={ImmediateFormatViewer(orderData2,setOrderData2)}/>
            <Button id='ShowLinkKeyCandidates' primary active={(!!orderData1 && !!orderData2)} onClick={() => { setLinkKeyModalOpen(true)  }}>Compare</Button>
            <ViewLinkKeyCandidatesModal isOpen={linkKeyModalIsOpen} onClose={()=>setLinkKeyModalOpen(false)} order1={orderData1} order2={orderData2}/>
        </>
    }

    return <>
        { DisplayOrdersSideBySide()}
    </>

}



export interface ViewLinkKeyCandidatesModalProps {
    isOpen: boolean
    onClose: () => void
    order1:string
    order2:string
}

type LinkCandidate = {
    key1:string
    data1:string
    key2:string
    data2:string
}

function ViewLinkKeyCandidatesModal(props:React.PropsWithChildren<ViewLinkKeyCandidatesModalProps>){

    const o1 :ImmediateFormatEntry[] = (props.order1 != "" ? JSON.parse(props.order1) : [])
    const o2:ImmediateFormatEntry[] = (props.order2 != "" ? JSON.parse(props.order2) : [])

    const candidates :LinkCandidate[] = []

    o1?.forEach(entry=>{
        o2?.forEach(entry2=>{
                if(!!entry.data && entry.data.length > 3 &&!!entry2.data && entry2.data.length > 3 && (entry2.data?.indexOf(entry.data) != -1 || entry.data?.indexOf(entry2.data) != -1)){
                    candidates.push({
                        key1:entry.key,
                        data1:entry.data,
                        key2:entry2.key,
                        data2:entry2.data
                    })
                }
            }
        )
    })

    return <Modal
        open={props.isOpen}
        onClose={props.onClose}
        dimmer="blurring"
        size='fullscreen'>
        <Header icon='browser' content='View potential Link keys' />
        <Modal.Content>

            <table>
                <tr><th>Key1</th><th>Data 1</th><th>Key 2</th><th>Data 2</th></tr>
                {
                    candidates.map(c=>{
                        return <tr>
                            <td>{c.key1}</td>
                            <td>{c.data1}</td>
                            <td>{c.key2}</td>
                            <td>{c.data2}</td>
                        </tr>
                    })
                }
            </table>

            <br />
            <Button id='SaveAsDraftModalCancelButton' onClick={() => props.onClose()}>Cancel</Button>

        </Modal.Content>
    </Modal>
}


